import { CSSProperties, ReactElement, ReactNode } from "react";
import { useLocation } from "react-router";
import { twMerge } from "tailwind-merge";
import { LOGIN } from "../../constants/routes";
import { useMenuDrawerContext } from "./MenuDrawerContextProvider.shared";
import { TooltipContainer } from "@sellar-io/components";

export type NavigationListElementBaseProps = {
  route?: string;
  onClick?(): void;
  children?: ReactNode;
  tooltipContent?: ReactNode;
  style?: CSSProperties;
  className?: string;
  hideMenuOnMobile?: boolean;
};

export const NavigationListElementBase = ({
  onClick,
  children,
  tooltipContent,
  style,
  className,
  route,
  hideMenuOnMobile = true,
}: NavigationListElementBaseProps): ReactElement => {
  const location = useLocation();
  const { isRailDisplayType, isMobileDisplayType, setIsOnScreen } =
    useMenuDrawerContext();

  const isElementPath = !!(
    route &&
    location.pathname !== LOGIN &&
    location.pathname.includes(route)
  );

  const listElement = (
    <div
      className={twMerge(
        isRailDisplayType && "w-[43px]",
        isElementPath && "bg-gray-100",
        className,
      )}
      onClick={() => {
        onClick?.();
        if (isMobileDisplayType && hideMenuOnMobile) setIsOnScreen(false);
      }}
      style={style}
    >
      {children}
    </div>
  );

  if (!isRailDisplayType || !tooltipContent) return listElement;

  return (
    <TooltipContainer
      enable
      placement="right"
      text={tooltipContent}
      className="w-fit"
    >
      {listElement}
    </TooltipContainer>
  );
};
